<template>
  <div>
    <v-select
      style="margin-top: 16px;"
      label="name"
      v-model="type"
      :options="productTypes"
      v-on:click:clear="typeCleared"
    ></v-select>
    <v-row align-content="end">
      <v-col :cols="12" align-self="end">
        <v-spacer></v-spacer>
        <v-btn @click="getInventoryReport">Generate</v-btn>
        <v-btn @click="exportreport">Export</v-btn>
      </v-col>
    </v-row>
    <v-simple-table ref="reporttable">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Product ID</th>
            <th class="text-left">Product Name</th>
            <th class="text-left">In Stock</th>
            <th class="text-left">Sold</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="product in products">
            <tr :key="product.id">
              <td class="text-left">{{ product.id }}</td>
              <td class="text-left">{{ product.name }}</td>
              <td class="text-left">{{ product.in_stock }}</td>
              <td class="text-left">{{ product.sold }}</td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select';
import { mapState, mapActions } from 'vuex';
import XLSX from 'xlsx';

export default {
  computed: {
    ...mapState({
      productTypes(state) {
        const products = [
          {
            id: 'all',
            name: 'All products'
          }
        ];
        return products.concat(state.ProductType.plainproductTypes);
      }
    })
  },
  mounted() {
    this['ProductType/fetchProductTypes']({ dontPaginate: false });
  },
  methods: {
    ...mapActions(['ProductType/fetchProductTypes']),
    getInventoryReport() {
      const params = {
        type: typeof this.type.id != 'undefined' ? this.type.id : ''
      };
      axios.get('api/v1/inventory/report', { params: params }).then(response => {
        this.products = response.data.data;
      });
    },
    typeCleared() {
      this.type = '';
    },
    exportreport() {
      const table = this.$refs.reporttable.$el;
      const wb = XLSX.utils.table_to_book(table, { raw: true });
      XLSX.writeFile(wb, 'sheetjs.xlsx');
    }
  },
  components: {
    vSelect
  },
  data: function() {
    return {
      datePickerMenu: false,
      dates: [],
      type: '',
      products: []
    };
  }
};
</script>
